import axios from "axios";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import ResultDeclaration from "./ResultDeclaration";
import PinDialog from "./PinDialog";

const arrayDates = (new Array(3)).fill("");
const arrayOfTime = (new Array(24)).fill("");
const Table = () => {
  const [data, setData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(
        "https://lw-lottery-api-twkwng2veq-em.a.run.app/api/tenant/1/draw-result",{
          params:{
            orderBy: "drawTime_DESC",
            limit: 500, // 24*arrayDates.length,
            offset:0
          }
        }
      );

      setData(response.data?.rows);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onResultDeclare = () => {
    fetchData();
  };

  const getResultForDateTime = (dateTime) => {

    if (!data) {
      return { main: "-", secondary: "-" };
    }

    const drawResult = data.filter(dr => dr.drawTime).find(dr => {
      // console.log(moment(dr.drawTime).startOf("hour").toDate())
      return moment(dr.drawTime).startOf("hour").isSame(dateTime)
    });

    return drawResult?.result || { main: "-", secondary: "-" };
  }

  return (
    <>
      {isModalOpen ? (
        <PinDialog onClose={handleModalClose} />
      ) : (
        <Wrapper>
          <ResultDeclaration onResultDeclare={onResultDeclare} />

          <table>
            <tbody>
              {arrayDates.map((d, idx) => {
                const date = moment().add(-1 * idx, "day");
                return <><tr>
                  <th colSpan={24}>{date.format("LL")}</th>
                </tr>
                  <tr>
                    {arrayOfTime.map((h, idx) => <td style={{ background: "#ccc", width:"50px" }} key={idx}>{idx}</td>)}
                  </tr>
                  <tr>
                    {arrayOfTime.map((h, idx) => <td key={idx}>{getResultForDateTime(date.set("hour", idx).startOf("hour")).main}</td>)}
                  </tr>
                  <tr>
                    {arrayOfTime.map((h, idx) => <td key={idx}>{getResultForDateTime(date.set("hour", idx).startOf("hour")).secondary}</td>)}
                  </tr>
                </>
              })}
              <tr>
                {/* */}
              </tr>
              <tr>

                {/* {dayData.map((entry) => (
                        <td key={entry.drawTime}>
                          {moment
                            .utc(entry.drawTime)
                            .format("HH")}
                        </td>
                      ))} */}

              </tr>
              {/* <tr>
                {dayData.entries.map((entry) => (
                  <td key={entry.secondaryNumber}>
                    {entry.secondaryNumber}
                  </td>
                ))}
              </tr> */}
              {data &&
                data.map((dayData) => {
                  return (
                    <tr>
                      {/* {dayData.entries.map((entry) => (
                        <td key={entry.mainNumber}>{entry.mainNumber}</td>
                      ))} */}
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100vw;
  padding: 0 3px;
  table {
    margin: 0 auto;
    width: 100%;
    border-collapse: collapse;
    max-width: 960px;
    table-layout: fixed;
  }
    tbody{
    display: block;
    margin: 6px 0 12px 0;
    }

  th, td {
    border: 1px solid #ccc;
    text-align: center;
    font-size: clamp(0.1875rem, -0.1534rem + 2.2727vw, 1.125rem);
    font-weight: bold;
  }
  td {
    color: #FFFF00;
  }
  th {
    background: #212f3c;
    color: #fff;
    font-weight: bold;
  }

  @media only screen and (max-width: 600px) {
    th, td {
      font-size: clamp(0.125rem, -0.1rem + 2.2727vw, 1rem); /* Smaller font size on smaller screens */
    }
  }
`;
export default Table;
